import React from 'react';
import { motion } from 'framer-motion';
import { bookInfo } from '../../data/bookData';
import SectionHeading from '../SectionHeading';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const WhyMatters = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Why This Book Matters" subtitle="The Core" />
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p className="text-gray-300 leading-relaxed text-lg mb-6 text-center">
          <em>The Quantum Awakening</em> is, at its core, a book about <span className="text-white font-semibold">what it costs to survive yourselves</span> — and what becomes possible when you do. It does not pretend the climb was clean.
        </p>
        <p className="text-gray-400 leading-relaxed text-center mb-10">
          The 7.4 billion people lost between Earth's 2058 peak and its 2501 population of 3 billion are not statistics — they are teachers in Kinshasa, farmers walking to flooded Mumbai, water engineers dying of dehydration while saving others.
        </p>
        <div className="bg-brand-surface border border-brand-accent/20 rounded-2xl p-8 md:p-12 text-center box-glow mb-10">
          <p className="text-2xl md:text-3xl font-display font-bold text-white leading-relaxed mb-4">
            "{bookInfo.closingQuote}"
          </p>
          <p className="text-gray-500 text-sm">— closing words of the chronicle</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href={bookInfo.links.amazon.kindle} target="_blank" rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-accent text-brand-dark rounded-lg font-bold hover:bg-brand-accentHover transition-colors">
            Read It Now <SafeIcon icon={FiArrowRight} />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WhyMatters;